import Modal from "Views/Components/Modal/Modal";
import { BoardDto } from "../DirectorSectionTypes";
import { Button, Colors, Display, Sizes } from "Views/Components/Button/Button";
import { ButtonGroup } from "Views/Components/Button/ButtonGroup";
import { SERVER_URL } from "Constants";
import axios from "axios";
import useAsync from "Hooks/useAsync";
import InlineSpinner from "Views/Components/Spinner/InlineSpinner";
import { CustomerEntity } from "Models/Entities";
import { BoardAsExistingCustomerSection } from "./BoardAsExistingCustomerSection";
import { BoardAsPotentialNewCustomer } from "./BoardAsPotentialNewCustomer";

const fetchAvailableCustomers = async (searchTerm: string, searchType: "ABN" | "ACN") => {
	const response = await axios.get<{data: CustomerEntity[], count: number}>(`${SERVER_URL}/api/entity/customerEntity`, {
		params: {
			searchTerm,
			searchType
		}
	});
	return response.data;
}

export interface ExtendedBoardDto extends BoardDto {
	searchType: "ACN" | "ABN";
	searchTerm: string;
}

type Props = {
	boardDetail: ExtendedBoardDto;
	isCurrent: boolean;
	onClose: () => void;
}

export const DirectorBoardSearchModal: React.FunctionComponent<Props> = ({
	boardDetail,
	isCurrent,
	onClose
}) => {
	const response = useAsync(async () => {
		const result = await fetchAvailableCustomers(boardDetail.searchTerm, boardDetail.searchType);
		return result;
	}, [boardDetail.searchTerm, boardDetail.searchType]);

	return (
		<Modal className="director-info-modal" label="" isOpen>
			<Button
				className="modal-close"
				key="header-cancel"
				icon={{ icon: 'cross', iconPos: 'icon-only' }}
				display={Display.Text}
				onClick={onClose}
				sizes={Sizes.Medium}
				colors={Colors.Error}
				labelVisible={false}
			>
				Cancel
			</Button>
			<div className="modal-header">
				<h4>{boardDetail.organisationName}</h4>
				
			</div>
			<div className="modal-body">
				{response.type === "loading" && <InlineSpinner />}
				{response.type === "error" && (
					<div className="alert alert__warning">
						<p>Please try again!! we're unable to find any matching entity with {boardDetail.searchTerm}({boardDetail.searchType}).</p>
					</div>
				)}
				{response.data && (
					<>
						{response.data.data.length === 0 && (<BoardAsPotentialNewCustomer board={boardDetail} isCurrent={isCurrent} />)}
						{response.data.data.length > 0 && (<BoardAsExistingCustomerSection customers={response.data.data} totalCount={response.data.count} />)}
					</>
				)}
			</div>
		</Modal>
	)
}